import { Box } from "@mui/material";
import withSx from "../../lib/withSx";

export const ChatBubble = withSx(Box, {
  display: "flex",
  flexDirection: "column",
  gap: 1,
  flexGrow: { xs: 0.25, md: 0.75 },
  borderRadius: 4,
  overflow: "hidden",
  px: 1.5,
  py: 1,
});

export const ChatHeader = withSx(Box, {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
});
